import routes from 'constants/routes';
import { useFeatureFlags } from 'hooks/useFeatures';
import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { ScreenLoader } from 'ui';
import { EFeatureFlags } from 'constants/features';
import { ENV, isITAREnvironment } from 'constants/env';

const About = React.lazy(() => import('pages/about'));
const Account = React.lazy(() => import('pages/account'));
const Dashboard = React.lazy(() => import('pages/dashboard'));
const Members = React.lazy(() => import('pages/members'));
const Settings = React.lazy(() => import('pages/settings'));
const SubscriptionsPlans = React.lazy(() => import('pages/subscriptionsPlans'));
const Thread = React.lazy(() => import('pages/thread'));
const NotFound = React.lazy(() => import('pages/NotFound'));
const TdpDetail = React.lazy(() => import('pages/tdp/detail'));
const TdpList = React.lazy(() => import('pages/tdp/list'));
const ModelPage = React.lazy(() => import('pages/model'));
const TemplateDetail = React.lazy(() => import('pages/template/detail'));

export const AuthenticatedRoutes = () => {
  const { features, isLoadingFeatureFlags } = useFeatureFlags();

  if (isLoadingFeatureFlags) {
    return <ScreenLoader />;
  }
  return (
    <Routes>
      <Route path="/" element={<Dashboard />} />
      {features[EFeatureFlags.UI_LIBRARY] && <Route path="/settings" element={<Settings />} />}
      <Route path={routes.account} element={<Account />} />
      <Route path={routes.members} element={<Members />} />
      <Route path={`${routes.thread}/:id`} element={<Thread />} />
      <Route path={`${routes.thread}/:id/messages/:msgId`} element={<Thread />} />
      <Route path={`${routes.thread}/:id/event/:eventId`} element={<Thread />} />
      {features[EFeatureFlags.THREADS_3D] && <Route path="model/:id" element={<ModelPage />} />}
      <Route path={`${routes.new_thread}`} element={<Dashboard />} />
      {!isITAREnvironment() && (
        <Route path={`${routes.subscriptionsPlans}/dashboard`} element={<SubscriptionsPlans />} />
      )}
      <Route path={`${routes.about}`} element={<About />} />
      {features[EFeatureFlags.BOEING_TDP] && (
        <Route path={routes.summaryReports} element={<TdpList />} />
      )}
      {features[EFeatureFlags.BOEING_TDP] && (
        <Route path={`${routes.summaryReports}/:id`} element={<TdpDetail />} />
      )}
      {features[EFeatureFlags.BOEING_TDP] && (
        <Route path={`${routes.template}/:id`} element={<TemplateDetail />} />
      )}
      <Route path="*" element={<NotFound />} />
      <Route path="/login" element={<Navigate to="/" />} />
      <Route path="/sign-up" element={<Navigate to="/" />} />
      {!isITAREnvironment() && (
        <Route
          path="/subscriptions-plans/auth"
          element={<Navigate to="/subscriptions-plans/dashboard" />}
        />
      )}
    </Routes>
  );
};
